import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { OODocumentationModel } from '@features/oneOnboarding/models/DocumentationModel';
import { OODocumentModel } from '@features/oneOnboarding/models/DocumentModel';
import { DCResultStatus } from '@features/oneOnboarding/models/UserDocumentModel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

import { DocumentActions } from '../DocumentActions/DocumentActions';
import { DocumentStatus } from '../DocumentStatus/DocumentStatus';

import styles from './DocumentItem.module.scss';

interface DocumentItemProps {
  document: OODocumentModel;
  documentation: OODocumentationModel;
  hasValidationStep: boolean;
}
export const DocumentItem: FC<DocumentItemProps> = ({ document, documentation, hasValidationStep }) => {
  const { t } = useTranslation(['documents', 'entry']);

  const renderDCStatus = (dcResult: DCResultStatus) => {
    const dcStatusConfig = {
      DISAPPROVED: {
        text: t('documents:verification.disapproved'),
        icon: <WarningIcon className={styles.dcStatusError} sx={{ fontSize: 20, marginRight: '8px' }} />,
      },
      APPROVED: {
        text: t('documents:verification.approved'),
        icon: <CheckCircleIcon className={styles.dcStatusApproved} sx={{ fontSize: 20, marginRight: '8px' }} />,
      },
      TECHNICAL_REJECT: {
        text: t('documents:verification.NotVerified'),
        icon: <WarningIcon className={styles.dcStatusWarning} sx={{ fontSize: 20, marginRight: '8px' }} />,
      },
    };

    const config = dcStatusConfig[dcResult];
    if (!config) return null;

    return (
      <div className={`${styles.dcStatus}`}>
        {config.icon}
        <span>{config.text}</span>
      </div>
    );
  };

  return (
    <>
      <div className="feature-candidate-profile__documents-item">
        <p className="tag-ds  medium">
          {t(`documents:${document.label}`)} {document.isMandatory ? '*' : ''}
        </p>
        <DocumentStatus document={document} hasValidationStep={hasValidationStep} />
        <DocumentActions documentModel={document} documentation={documentation} />
      </div>
      {document.userDocument?.dcDocumentVerificationResult && (
        <div className="feature-candidate-profile__documents-item-verification-status">
          {document.userDocument?.dcDocumentVerificationResult &&
            renderDCStatus(document.userDocument.dcDocumentVerificationResult)}
        </div>
      )}
    </>
  );
};
